import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class BillingConceptInsertService {
	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	addBillingConcept(token, clienttype: any) {
		return this.http
			.post(this.apiUrl + "billingconcepts/v1/insertbillingconcept", JSON.stringify(clienttype), JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-concept/service/billing-concept-insert/billing-concept-insert.service.ts